import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { showError, showSuccess } from '@/lib/dialogHelper'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import useEditFormData from '../common/useEditFormData'
import EditCollectionForm from '../common/EditCollectionForm'

export default function SingleCustomCollectionAdd() {
	const { t } = useTranslation()
	const { collectionId } = useParams()
	const [searchParams] = useSearchParams()
	const presetFieldName = searchParams.get('presetFieldName');
	const presetFieldLabel = searchParams.get('presetFieldLabel');
	const presetFieldValue = searchParams.get('presetFieldValue');
	const returnPath = searchParams.get('returnPath');

	const navigate = useNavigate()
	const { collectionDetails, formData, loading, error, setFieldValue, saveFormData } = useEditFormData({ collectionId })

	if (loading) { return <LoadingIndicator message={t('singleCustomCollection.add.loading')} /> }
	if (!collectionDetails) {
		showError(error || t('singleCustomCollection.add.messages.collectionNotFound'))
		return null
	}

	const collectionDisplayName = collectionDetails?.displayName || collectionDetails?.name || ''

	const handleSave = async () => {
		const { data, error } = await saveFormData()
		if (error) { 
			showError(t('singleCustomCollection.add.messages.createFailed', { error }))
			return; 
		}
		if (data) {
			// showSuccess('New item has been created successfully.')
			if (data._id) {
				if (returnPath) { return navigate(returnPath) }
				return navigate(`/single-custom-collection/${collectionId}/details/${data._id}`)
			}
			return navigate(`/single-custom-collection/${collectionId}`)
		}
	}

	return (
		<div>
			<EditCollectionForm
				title={t('singleCustomCollection.add.title', { name: collectionDisplayName })}
				description={t('singleCustomCollection.add.description', { name: collectionDisplayName })}
				collectionDetails={collectionDetails}
				formData={formData}
				onFieldChange={setFieldValue}
				onSave={() => handleSave()}
				submitLabel={t('singleCustomCollection.add.actions.save')}
				presetFieldName={presetFieldName}
				presetFieldLabel={presetFieldLabel}
				presetFieldValue={presetFieldValue}
			/>
		</div>
	)
}
